(() => {
  const HIDDEN = 'do-not-show hide'; // Hidden classes for desktop and mobile
  const suggestCharMin = window.searchCultureConfig.suggestCharMin || 3;


  /**
   * Clears currently active suggestion
   */
  const clearActiveSuggestion = () => {
    $('.suggestion--active').removeClass('suggestion--active');
  };


  /**
   * Extend base suggestion params to include search term
   *
   * @param  {string} searchTerm - Search term typed into search bar
   * @return {Object}            - CloudSearch request parameters
   */
  const getSuggestParams = (searchTerm) => {
    return {
      id: 'suggestions',
      index: wmUtil.searchIndex,
      params: {
        searchTerm: searchTerm
      }
    };
  };

  /**
   * Extend base top product params to include search term
   * and optionally filter query, if category is defined
   *
   * @param  {string} searchTerm - Suggested search term
   * @param  {string} category   - Suggested category (optional)
   * @return {Object}            - CloudSearch request parameters
   */
  const getTopProductParams = (searchTerm, category) => {
    const reqParams = {
      id: 'top_products',
      index: wmUtil.searchIndex,
      params: {}
    };

    if (wmUtil.pointsRegex.test(searchTerm)) {
      reqParams.params.points = searchTerm.match(wmUtil.pointsRegex)[1];
    } else {
      reqParams.params.searchTerm = searchTerm;
    }

    if (wmUtil.isDefined(category)) {
      reqParams.params.category = category;
    }

    return reqParams;
  };

  /**
   * Creates suggestion ID used in Analytics tracking tag
   *
   * @param  {string} suggestionTerm - suggested search term
   * @param  {string} category       - category for filtering suggestions
   * @return {string}                - ID to use in tracking tag
   */
  const getSuggestID = (suggestionTerm, category) => {
    return wmUtil.isDefined(category) ? (suggestionTerm + ',' + category) : suggestionTerm ;
  };


  // **************
  // Shared Angular service
  // **************

  //

  /**
   * Intermediary app to enable sharing data between Angular apps
   */
  const sharedServiceApp = angular.module('sharedService', []);


  // Services
  // **************
  sharedServiceApp.service('searchSync', ['$rootScope', '$window', '$location',
    ($rootScope, $window, $location) =>{
      let searchTerm = wmUtil.getParamByName('q') || '';
      let category = wmUtil.getParamByName('category') || '';

      $window.rootScopes = $window.rootScopes || [];
      $window.rootScopes.push($rootScope);

      if (!!$window.sharedSearchService){
        return $window.sharedSearchService;
      }

      $window.sharedSearchService = {
        /**
         * Updates search term and category values,
         * then applies changes to all app scopes
         *
         * @param  {string} newTerm     - new search term
         * @param  {string} newCategory - new category
         */
        updateQuery: (newTerm, newCategory) => {
          searchTerm = newTerm;
          category = newCategory;

          angular.forEach($window.rootScopes, (scope) => {
            scope.$broadcast('searchTermUpdate', {
              searchTerm: newTerm,
              category: newCategory
            })
          });
        },

        /**
         * Retrieves current search term and category
         *
         * @return {Object} - Object with key-value pairs
         *                    for searchTerm and category
         */
        getQuery: () => {
          return {
            searchTerm: searchTerm,
            category: category
          };
        }
      };

      return $window.sharedSearchService;
    }
  ]);


  // **************
  // Search Bar App
  // **************

  const searchBarApp = angular.module('searchBar', ['sharedService']);


  // Config
  // **************
  searchBarApp.config(['$locationProvider',
    ($locationProvider) => {
      $locationProvider.html5Mode(true);
    }
  ]);

  // Directives
  // **********
  searchBarApp.directive('customInput', () => {
    return {
      restrict: 'A',
      require: '^ngModel',
      scope: {
        ngModel: '=', // sync model
      },
      link:  (scope, element, attrs, ngModel) => {
        element.off('compositionstart').off('compositionend');
        element.on('input', () => {
          scope.ngModel = element.val();
          scope.$eval(attrs.cstInput, {'searchTerm': scope.ngModel});
        });
      }
    };
  });

  // Rendered Components
  // *******************

  searchBarApp.directive('searchControls', () => {
    return {
      restrict: 'E',
      template: '<search-input></search-input>' +
                '<suggestion-list class="suggestion-list-container" ng-if="showSuggestions && suggestions.length > 0"></suggestion-list>'
    };
  });

  searchBarApp.directive('searchInput', () => {
    return {
      require: 'ngModel',
      restrict: 'E',
      // NOTE: form class changed to 'wm-search-form' for new header
      template: '<form class="wm-search-form" action="." ng-submit="submitSearch($event)">' +
                  '<input class="search-input" id="js-search-input" type="search" placeholder="{{ cultureConfig.searchBoxLabel }}" aria-label="{{ cultureConfig.searchBoxLabel }}" custom-input ng-model="searchTerm" ng-focus="focusSearchBar()" ng-keydown="searchBarArrow($event)" autocomplete="off" spellcheck="false" autocapitalize="none" autocorrect="off" tabindex="0"/>' +
                  '<button class="search-submit-button pure-button pure-button-green" type="submit" ng-click="submitSearch($event)"><span class="fa fa-search"></span>&nbsp;</button>' +
                  '<button class="search-clear-button" type="reset" ng-click="clearSearchTerm()" ng-if="isMobileSite && searchTerm.length">' +
                    '<i class="fa fa-times-circle"></i>' +
                  '</button>' +
                '</form>'
    };
  });

  searchBarApp.directive('suggestionList', () => {
    return {
      restrict: 'E',
      template: '<ol class="suggestion-list" id="js-suggestion-list">' +
                  '<li class="suggestion-item" tabindex="0" ng-repeat="suggestion in suggestions" ng-keydown="suggestionArrow($event, suggestion.term)" ng-focus="suggestionActive($event, suggestion.term)">' +
                    '<span class="suggestion-item-text" ng-click="submitSuggestion(suggestion.term)" ng-mouseover="suggestionActive($event, suggestion.term)" ng-mouseout="suggestionMouseout()">{{ suggestion.term }}</span>' +
                    '<ol id="js-category-list" ng-if="$first">' +
                      '<li class="suggestion-category" ng-repeat="category in suggestion.categories | limitTo:5" ng-click="submitSuggestion($parent.suggestion.term, category.name)" ng-mouseover="suggestionActive($event, $parent.suggestion.term, category.name)" ng-mouseout="suggestionMouseout()" ng-keydown="suggestionArrow($event, $parent.suggestion.term, category.name)" ng-focus="suggestionActive($event, $parent.suggestion.term, category.name)" tabindex="0">{{ interpolate(cultureConfig.suggestionInCategory, {category: {name: category.name} }) }}</li>' +
                    '</ol>' +
                  '</li>' +
                '</ol>' +
                '<top-products class="top-products-container" ng-if="topProducts.length"></top-products>'
    };
  });

  searchBarApp.directive('topProducts', () => {
    return {
      restrict: 'E',
      template: '<div class="top-products">' +
                  '<h3 class="top-products-header">' +
                    '<span ng-show="!hoverCategory.length">{{ interpolate(cultureConfig.topResults) }}</span>' +
                    '<span ng-show="hoverCategory.length">{{ interpolate(cultureConfig.topResultsCategory) }}</span>' +
                  '</h3>' +
                  '<ol class="top-products-list">' +
                    '<li class="top-products-item" ng-repeat="product in topProducts">' +
                      '<div class="top-products-item-upper">' +
                        '<a class="top-products-image-link" ng-href="/ProductStore/Product?sku={{ product.sku }}" ng-click="viewProductDetails(product.sku)">' +
                          '<img class="top-products-image" ng-src="{{ contentImagesDirectory }}/{{ product.image }}" />' +
                        '</a>' +
                        '<button class="top-products-add-to-cart" ng-if="signedIn" id="search-suggest-add-to-cart-{{ product.sku }}" data-sku="{{ product.sku }}" ng-click="addToCart($event)">' +
                          '<span class="fa fa-plus"></span><span class="fa fa-shopping-cart"></span>' +
                        '</button>' +
                      '</div>' +
                      '<h4 class="top-products-title">'+
                        '<a class="top-products-title-link" ng-href="/ProductStore/Product?sku={{ product.sku }}" ng-click="viewProductDetails(product.sku)" ng-bind-html="product.name"></a>' +
                      '</h4>' +
                    '</li>' +
                  '</ol>' +
                  '<button class="wm-btn wm-btn-secondary top-products-search-btn" ng-click="submitSearch($event, true, hoverCategory)">{{ cultureConfig.viewResults }}</button>' +
                '</div>'
    };
  });


  // Services
  // **************

  searchBarApp.service('suggestSvc', ['$http', 'dataService', ($http, dataService) => {
    // const suggestions = [];
    const services = {};
    /**
     * Fetches query suggestions from suggest API
     *
     * @param  {Object} queryParams - CloudSearch request parameters
     * @param  {Function} callback  - Handler for result data
     */
    services.getSuggestions = (queryParams, callback) => {
      dataService.getSearchResults(queryParams)
      .success((data) => {
        if (data.hits.total) {
          callback(data.hits.hits);
        }
      }).error((data) => {
        console.log('error getting suggestions: ', data);
      });
    };

    /**
     * Fetches most popular products from search API
     *
     * @param  {Object} queryParams - CloudSearch request parameters
     * @param  {Function} callback  - Handler for result data
     */
    services.getTopProducts = (queryParams, callback) => {
      dataService.getSearchResults(queryParams)
      .success((data) => {
        if (data.hits.total) {
          callback(data.hits.hits);
        }
      }).error((data) => {
        console.log('error getting top products: ', data);
      });
    };

    return services;
  }]);


  // Controller
  // **************

  searchBarApp.controller('searchBarController', ['$rootScope', '$scope', '$window', '$location', '$sce', '$interpolate', '$sceDelegate', '$document', '$timeout', 'suggestSvc', 'searchSync',
    ($rootScope, $scope, $window, $location, $sce, $interpolate, $sceDelegate, $document, $timeout, suggestSvc, searchSync) => {
      $scope.signedIn = PageClientData.CustomerStatus;
      $scope.isMobileSite = wmUtil.isMobileSite;
      $scope.contentImagesDirectory = $window.contentImagesDirectory;
      $scope.searchTerm = '';
      $scope.category = '';
      $scope.hoverTerm = '';
      $scope.hoverCategory = '';
      $scope.suggestions = [];
      $scope.showSuggestions = false;
      $scope.topProducts = [];
      $scope.cultureConfig = $window.searchCultureConfig;
      $scope.showSearchScopes = false;



      // Timer for suggestion request
      let suggestionTimer;

      //
      // Watch searchTerm for changes, and fire getSuggestions on change
      $scope.$watch('searchTerm', (newVal, oldVal) => {
        $scope.getSuggestions();
      });


      /**
       * Scope function to handle fetching search results
       *
       * @param  {Boolean} isHover - Indicates whether to use search term
       *                             and category from hover event
       */
      $scope.getSearchResults = (isHover) => {
        isHover = isHover || false;
        let searchTerm = $scope.searchTerm;
        let category = $scope.category;

        $scope.showSuggestions = false;
        $timeout.cancel(suggestionTimer);

        if (isHover) {
          searchTerm = $scope.hoverTerm;
          category = $scope.hoverCategory;
        }

        // If we're on the search results page, update the search term and category
        try {
          if(!!angular.module('searchResults')) {
            searchSync.updateQuery(searchTerm, category);
          }
        } catch (e) { // Otherwise, load search results page with query params
          const categoryString = (category !== '' ) ? '&category=' + encodeURIComponent(category) : '';
          const queryParams = 'q=' + encodeURIComponent(searchTerm) + categoryString;
          $window.location.href = $window.location.origin + '/search-results?' + queryParams;
        }

        if (wmUtil.isMobileSite) {
          $scope.closeMobileSearch();
        }
      };

      /**
       * Scope function to handle fetching suggestions
       *
       * @param  {Object} event - DOM event
       */
      $scope.getSuggestions = () => {
        if ($scope.searchTerm.length >= suggestCharMin) {
          $timeout.cancel(suggestionTimer);
          suggestionTimer = $timeout(() => {
            suggestSvc.getSuggestions(getSuggestParams($scope.searchTerm), (suggestions) => {
              $scope.suggestions = suggestions.map((suggestion) => {
                return {
                  term: suggestion._source.suggestion.term,
                  categories: suggestion._source.suggestion.categories
                };
              });
              $scope.showSuggestions = true;
            });
          }, 250);
        } else {
          $scope.suggestions = [];
          $scope.topProducts = [];
        }
      };

      /**
       * Submit handler for search form
       *
       * @param  {Object}  event    - DOM event (submit)
       * @param  {Boolean} isHover  - Indicates whether to use search term
       *                              and category from hover event
       * @param  {string}  category - Optional category name to filter by
       */
      $scope.submitSearch = (event, isHover, category) => {
        event.preventDefault();
        isHover = isHover || false;
        if (!wmUtil.isDefined(category)) {
          $scope.category = '';
        }
        $scope.getSearchResults(isHover);
      };

      /**
       * Submits a suggested term and category as a search request.
       *
       * @param  {string} suggestionTerm - Suggested query term
       * @param  {string} category       - Suggested category (optional)
       */
      $scope.submitSuggestion = (suggestionTerm, category) => {
        category = category || '';
        $scope.category = category;
        $scope.hoverCategory = category;
        $scope.searchTerm = suggestionTerm;
        $scope.hoverTerm = suggestionTerm;
        $scope.suggestions = [];

        // Only submit suggestion if a search term is provided
        if (suggestionTerm.length > 0) {
          $scope.getSearchResults(true);
        }

        if (wmUtil.isMobileSite) {
          $scope.closeMobileSearch();
        }
      };

      /**
       * Get basic information for top products,
       * based on suggestion term and category.
       *
       * @param  {string} suggestionTerm - Suggested search term
       * @param  {string} category       - Suggested category
       */
      $scope.getTopProducts = (suggestionTerm, category) => {
        category = category || '';
        $scope.hoverCategory = category;
        $scope.hoverTerm = suggestionTerm;

        suggestSvc.getTopProducts(getTopProductParams(suggestionTerm, category), (topProducts) => {
          $scope.topProducts = topProducts.map((product) => {
            const fields = { sku: product._source.sku };
            if (product._source.hasOwnProperty('name')) {
              fields.name = $sce.trustAsHtml(product._source.name.regular);
            }
            if (product._source.hasOwnProperty('image')) {
              fields.image = product._source.image.regular;
            }

            return fields;
          });
        });
      };


      const tabbable = '[tabindex]';

      /**
       * Arrow down to move from search bar to suggestion list
       *
       * @param {Object} event - DOM event (keydown)
       */
      $scope.searchBarArrow = (event) => {
        $timeout(() => {
          const target = $(event.target);
          const firstSuggestion = $('#js-suggestion-list > ' + tabbable + ':first-child');
          if (event.key === 'Escape') {
            target.blur();
          } else if (event.key === 'ArrowDown') {
            firstSuggestion.focus();
          }
        });
      };

      /**
       * Arrow up/down to navigate suggestion list
       *
       * @param {Object} event - DOM event (keydown)
       */
      $scope.suggestionArrow = (event, suggestionTerm, category) => {
        event.preventDefault();
        event.stopPropagation();
        $timeout(() => {
          const target = $(event.target);
          if (event.key === 'ArrowDown') {
            const lastCategory = $('#js-category-list > ' + tabbable + ':last-child');
            if (target.find(tabbable).length > 0) {
              // Enter category sublist
              target.find(tabbable).first().focus();
            } else if (target[0] === lastCategory[0]) {
              // Exit category sublist
              target.parents().closest(tabbable).next().focus();
            } else {
              // Go to next sibling
              target.next(tabbable).focus();
            }
          } else if (event.key === 'ArrowUp') {
            const firstItem = $('#js-suggestion-list > ' + tabbable + ':first-child');
            const firstCategory = $('#js-category-list > ' + tabbable + ':first-child');
            if (target[0] === firstItem[0]) {
              clearActiveSuggestion();
              // Return to search input
              $('#js-search-input').focus();
            } else if (target[0] === firstCategory[0]) {
              // Exit category sublist
              target.parents().closest(tabbable).focus();
            } else {
              if (target.prev(tabbable).find(tabbable).length > 0) {
                // Enter category sublist
                target.prev(tabbable).find(tabbable).focus();
              } else {
                // Go to previous sibling
                target.prev(tabbable).focus();
              }
            }
          } else if (event.key === 'Enter') {
            $scope.submitSuggestion(suggestionTerm, category);
          }
        });
      };



      /**
       * Toggles the active suggestion term, calls getTopProducts to
       * display a list of the top products for a term and optional category.
       *
       * @param  {event}  event          - DOM event (mouseover, keydown)
       * @param  {string} suggestionTerm - suggested query term
       * @param  {string} category       - optional category for query
       */
      let activeTimer;
      $scope.suggestionActive = (event, suggestionTerm, category) => {
        if (!wmUtil.isMobileSite) {
          clearActiveSuggestion();
          $timeout.cancel(activeTimer);
          const target = $(event.target);
          if (target.parent(tabbable).length > 0) {
            target.parent().addClass('suggestion--active');
          } else {
            target.addClass('suggestion--active');
          }
          activeTimer = $timeout(() => {
            $scope.getTopProducts(suggestionTerm, category);
          }, 300);
        }
      };

      /**
       * Cancels timeout timer when user moves
       * mouse away from hovering a suggestion
       */
      $scope.suggestionMouseout = () => {
        $timeout.cancel(activeTimer);
      };

      /**
       * Add product to mini-cart
       */
      $scope.addToCart = (event) => {
        $window.AnimateAddToDest($get($(event.currentTarget).attr('id')), 'miniCartIcon');
        $window.Melaleuca.Web.AjaxManager.AddProductToCart($(event.currentTarget).data('sku'), 1, 'Site Search - Suggestions', null, rtnAddToCart);
      };

      $scope.viewProductDetails = (sku) => {
        $window.location.href = '/ProductStore/Product?sku=' + sku;
      };

      /**
       * Change search area (e.g. 'All', 'Product Store', etc.)
       *
       * @param  {Object} searchScope - Selected search scope, see
       *                                `searchCultureConfig.searchScopes`
       */
      $scope.changeSearchScope = (searchScope) => {
        if (searchScope.oldSearch) {
          $window.SetSearchArea(searchScope.selector, searchScope.value, searchScope.title);
          showLegacySearch();
        } else {
          showNewSearch();
        }
      };

      /**
       * Helper actions when focusing search bar
       * - Hides minicart if it's open
       * - Removes active search suggestion
       * - Shows suggestions if 3 or more characters
       */
      $scope.focusSearchBar = () => {
        $('#mycart:visible').hide();
        clearActiveSuggestion();
        if ($scope.searchTerm.length >= suggestCharMin) {
          $scope.showSuggestions = true;
        }
      };

      $scope.clearSearchTerm = () => {
        $scope.searchTerm = '';
        $scope.category = '';
        $scope.showSuggestions = false;
        $scope.suggestions = [];
        $scope.topProducts = [];
      };

      $scope.interpolate = (string, scope) => {
        const context = scope || $scope;
        return $interpolate(string)(context);
      };

      /**
       * Clicking outside search controls
       * disables suggestion dropdown list
       *
       * @param  {Object} event - DOM event (click)
       */
      $scope.$watch('showSuggestions', (newVal, oldVal) => {
        if (newVal) $document.on('click', handleDocumentClick);
      })

      const handleDocumentClick = (event) => {
        clearActiveSuggestion();
        const isSearchBarChild = $('#amazon-search-bar').find(event.target).length > 0;
        if (!isSearchBarChild) {
          $timeout(() => {
            $scope.showSuggestions = false;
            $document.off('click', handleDocumentClick);
          });
        }
      }

      /**
       * Helper actions when moving away from mobile search bar
       */
      $scope.closeMobileSearch = () => {
        $scope.showSuggestions = false;
        $('#js-search-input').blur();
        $('#js-blackout').removeClass('active');
        $('#js-top-push').removeClass('active active-search');
        $('#js-nav-search').css('display', '');
      };
    }
  ]);

  angular.bootstrap(document.getElementById('amazon-search-bar'), ['searchBar', 'sharedService', 'ngWmUtil']);
})();
